import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=c9f01c1e&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=c9f01c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f01c1e",
  null
  
)

export default component.exports